
export default {
  props: {
    initialFixture: {
      type: Object,
      required: true,
    },
    fixtureToGoLiveInFiveMinutes: {
      type: Boolean,
      required: true,
    },
  },
  data () {
    return {
      fixture: {},
      fixtureHasGoneLive: false,
      interval: null,
      refresh: false,
    };
  },
  watch: {
    fixtureToGoLiveInFiveMinutes: {
      immediate: true,
      handler (fixtureToGoLiveInFiveMinutes) {
        if (fixtureToGoLiveInFiveMinutes) this.refresh = true;
      },
    },
    fixtureHasGoneLive: {
      immediate: true,
      handler (fixtureHasGoneLive) {
        if (fixtureHasGoneLive) {
          this.$emit(`fixtureHasGoneLive`);
        }
      },
    },
    refresh: {
      immediate: true,
      handler (refresh) {
        if (refresh) {
          this.interval = setInterval(() => {
            const fixtureHasGoneLive =
              this.fixture?.state?.fixtureGrouping === `Live`;

            this.getLatestResult({
              id: this.fixture.id,
              assignmentFn: ({ response }) => {
                this.fixture = {};
                this.fixture = response?.data;

                // NOTE: we also need to only mutate the `fixture` prop inside of our `displayFixture` object, because the other props are reliably static;
                // the other props were also manually placed there, and so we don't want to repeat that process from `Fixtures.vue`.
              },
            });

            if (
              fixtureHasGoneLive &&
              !this.isFixtureAbandoned(this.fixture) &&
              !this.isFixturePostponed(this.fixture)
            ) {
              this.fixtureHasGoneLive = true;
            }
          }, 20000);
        } else {
          clearInterval(this.interval);
        }
      },
    },
  },
  created () {
    this.fixture = this.objectDeepCopy(this.initialFixture);
  },
  beforeDestroy () {
    clearInterval(this.interval);
  },
};
